import MaterialCategoryEdit from '@/components/material/category/edit/MaterialCategoryEdit.vue'
import { mapState } from 'vuex'

export default {
  name: 'MaterialCategoryListExpand',
  props: {
    data: Object
  },
  components: {
    MaterialCategoryEdit
  },
  computed: {
    ...mapState(['config']),
    tableHeaders () {
      const headers = [
        { key: 'id', label: this.$t('material-category.title'), format: 'formatFromConfig', configKey: 'material_categories', configParam: 'name' },
        { key: 'code', label: this.$t('general.item.code') },
        { key: 'all_subcategories.length', label: this.$t('material-category.subcategory_count') },
        { key: 'material_group_id', label: this.$t('material-group.title'), format: 'formatFromConfig', configKey: 'material_groups', configParam: 'name' },
        { key: 'from_date_period_id', label: this.$t('general.filters.date-period-from'), format: 'formatDatePeriod' },
        { key: 'to_date_period_id', label: this.$t('general.filters.date-period-to'), format: 'formatDatePeriod' },
        { key: 'order', label: this.$t('general.item.order') }
      ];
      const actions = [
        { label: this.$t('menu.material.category.edit'), emit: 'editItem', icon: 'edit', bicon: 'pencil-fill' },
        { label: this.$t('menu.material.category.delete'), emit: 'deleteItem', icon: 'delete', bicon: 'trash', ifconfig: { param: 'deleted_at', value: null } },
        { label: this.$t('menu.material.category.restore'), emit: 'restoreItem', icon: 'restore', bicion: 'clock-history', ifconfig: { param: 'deleted_at', value: null, notCheck: true } }
      ];
      headers.push({ key: 'actions', label: '', actions: actions });
      return headers;
    },
    tableExpandConfig () {
      return { component: 'MaterialCategoryListExpand', ifconfig: { param: 'all_subcategories.length', value: 0, notCheck: true } };
    }
  },
  methods: {
    setDeleted (el, isDeleted) {
      this.loading = true;
      const self = this;
      this.ApiRequest.request('material/category/deleted', this.ApiRequest.REQUEST_POST, { code: el.code, deleted: isDeleted }, function (response) {
        if (response.error) {
          self.ApiRequest.displayErrorDialog(response, self);
          self.loading = false;
        } else {
          self.itemUpdated();
        }
      });
    },
    itemUpdated () {
      this.$emit('saved');
    },
    editItem (el) {
      this.$refs.editElFrm.show(el);
    },
    deleteItem (el, approved) {
      if (approved) {
        this.setDeleted(el, 1);
      } else {
        this.$refs.itemDeleteMsgBox.show(el, this.$t('material-category.deleteTitle'), this.$t('material-category.deleteMessage', { categoryName: this.BasicHelper.getTranslation(el.name) }))
      }
    },
    restoreItem (el) {
      this.setDeleted(el, 0);
    }
  }
}
